import { Routes, Route } from "react-router-dom";
import Home from "./Landing/Home";
import MainLayout from "./Shared/MainLayout";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Blog from "./Blog/Blog";
import Post from "./Blog/Post";
import Error404 from "./Error404";
import Optimization from "./Optimization/Optimization";
import PublicOffer from "./PublicOffer/PublicOffer";
import useScrollToTopOnPathChange from "./Shared/useScrollToTopOnPathChange";
import ThankYouPage from "./ThankYouPage/ThankYouPage";
import MainLayoutDW from "./Doorway/MainLayoutDW";
import ThankYouPageDW from "./Doorway/ThankYouPageDW";
import HomeDW from "./Doorway/HomeDW";

const AppRoutes = () => {
  useScrollToTopOnPathChange();
  const { i18n } = useTranslation();

  // const lang = localStorage.getItem("lang");
  // useEffect(() => {
  //   i18n.changeLanguage(lang);
  // }, []);
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:postId" element={<Post />} />
        <Route path="/google-maps-optimization" element={<Optimization />} />
      </Route>
      <Route path="/public-offer" element={<PublicOffer />} />
      <Route path="*" element={<Error404 />} />
      <Route path="/thank-you" element={<ThankYouPage />} />
      <Route path="/doorway" element={<MainLayoutDW />}>
        <Route path="/doorway" element={<HomeDW />} />
      </Route>
      <Route path="/doorway/thank-you" element={<ThankYouPageDW />} />
    </Routes>
  );
};

export default AppRoutes;
